import logInfoApi from '@/apis/logInfoApi';

const state = () => ({
    searchInfo: null,
});

let searchDataSeq = 0;

const hasMacAddress = (data) => {
    const macAddress = data?.macAddress;
    return (
        macAddress !== undefined &&
        macAddress !== null &&
        macAddress !== '' &&
        macAddress !== 'noData'
    );
};

async function fetchMongoModelId(macAddress) {
    try {
        const response = await logInfoApi.getProductLogList({
            deviceId: macAddress,
            pageSize: 1,
            lastId: '',
            orderSort: 'desc',
        });
        return response?.data?.list?.[0]?.modelId || '';
    } catch (error) {
        return '';
    }
}

const getters = {
    getSearchData: state => state.searchInfo,
};

const actions = {
    // 선택한 제품. 모델고유코드는 다른 제품을 고르기 전까지 유지한다.
    async setSearchData({commit, state}, data){
        if (isSameSearchData(state.searchInfo, data)) {
            return;
        }
        const seq = ++searchDataSeq;
        let payload = data || {};
        if (hasMacAddress(payload) && payload.mongoModelId == null) {
            const mongoModelId = await fetchMongoModelId(payload.macAddress);
            if (seq !== searchDataSeq) {
                return;
            }
            payload = { ...payload, mongoModelId };
        }
        if (seq !== searchDataSeq) {
            return;
        }
        commit('SET_SEARCH_DATA', payload);
    }
};

const isSameSearchData = (prev, next) => {
    if (prev === next) return true;
    if (!prev || !next) return false;
    return (
        prev.id == next.id &&
        prev.macAddress === next.macAddress &&
        prev.storeId == next.storeId &&
        prev.productSn === next.productSn &&
        prev.modelCode === next.modelCode &&
        prev.outModelCode === next.outModelCode
    );
};

const mutations = {
    SET_SEARCH_DATA(state, payload) {
        if (isSameSearchData(state.searchInfo, payload)) {
            return;
        }
        state.searchInfo = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
 